const watermark = () => import('@/pages/product/watermark/index.vue');

export default [{
    path: '/product/watermark',
    component: watermark,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '产品水印',
        activeRoute: '/product/watermark'
    }]
}];